/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

$(document).ready(function(){
  $(document).on('click','.accor-title',function(e){
    e.preventDefault();
    var parent = $(this).closest('.main-accordion');
    $(parent).toggleClass('open');
    $(parent).find('.block-desc').slideToggle()
  })
  document.addEventListener('cart:updated', function(event) {
    console.log('here');
    var cart = event.detail.cart; // Get the updated content of the cart
    var cartTotal = cart.total_price,
        selector = $('#mini-cart'),
        freeGiftPrice1 = parseInt(selector.attr('data-gift_1_price')),
        freeGiftPrice2 = parseInt(selector.attr('data-gift_2_price')),
        freegigtVar1 = selector.attr('data-gift_1_variant'),
        freegigtVar2 = selector.attr('data-gift_2_variant'),
        inCartFreeGift1 = $(document).find('#progress-bar-content').attr('data-freegift1incart'),
        inCartFreeGift2 = $(document).find('#progress-bar-content').attr('data-freegift2incart');


      // if(cartTotal >= freeGiftPrice1 && cartTotal < freeGiftPrice2 ){
      //   ///add freeGift 1 and remove free gift 2 if in cart
      //   if( inCartFreeGift1 == '0' ){
      //     console.log('condition 1')
      //     addToCart(freegigtVar1,1);
      //   }

      //   if( inCartFreeGift2 == '1' ){
      //     console.log('condition 2')
      //     removeFromCart(freegigtVar2);
      //   }
        
      // }else if( cartTotal >= freeGiftPrice2 ){
      //   /// add free gift 2 and 1 in cart with qty 1
      //   if( inCartFreeGift2 == '0' ){
      //     console.log('condition 3')
      //     addToCart(freegigtVar2,1);
      //   }
      //   if( inCartFreeGift1 == '0' ){
      //     console.log('condition 4')
      //     addToCart(freegigtVar1,1);
      //   }
      // }else if(cartTotal < freeGiftPrice1){
      //   console.log('remove 4')
      //   removeFromCart(freegigtVar2);
      //   removeFromCart(freegigtVar1);
      // }
    
  });

  
  $(document).on('click','.add-free-item',function(){
    var parent = $(this).closest('.product-itemd'),
        varId = $(parent).find('[name="var"]').val();
    $(this).addClass('disabled');
    $(parent).find('.line-item__loader,.line-item__loader-spinner').removeAttr('hidden')
    setTimeout(function(){
      addToCart(varId,1);
    },200)
      
  })

  $(document).on('click','upsell-collection-tabs-toggle',function(){
    var parent = $(this).closest('.minicart-addon');
    $(parent).find('nav upsell-collection-tabs-toggle').removeClass('active');

    $(this).addClass('active');
    var handle =$(this).attr('data-collection-handle');
    $(parent).find('upsell-collection-tabs-panel').removeClass('in');
    $(parent).find('upsell-collection-tabs-panel[data-collection-handle="'+handle+'"]').addClass('in');
  })

  if($(document).find('[data-tabid="products_1"]').length > 0){
    $('.size-swatches').removeClass('selected-pro');
    $('.size-swatches[data-tab="products_1"]').addClass('selected-pro');
    var image = $(document).find('[data-tabid="products_1"] .selected-pro').attr('data-image');
    $(document).find('.size-swatches[data-tab="products_1"].selected-pro .pro-image').css('background-image', 'url(' + image + ')');
    console.log(image)
    
  }
  if($(document).find('[data-tabid="products_2"]').length > 0){
    $('.size-swatches').removeClass('selected-pro');
    $('.size-swatches[data-tab="products_2"]').addClass('selected-pro');
    var image = $(document).find('[data-tabid="products_2"] .selected-pro').attr('data-image');
    $(document).find('.size-swatches[data-tab="products_2"].selected-pro .pro-image').css('background-image', 'url(' + image + ')');
    console.log(image)
  }
    
   function setCookie(name,value,days) {
      var expires = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }
    function getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
      }
      return null;
    }
  function addToCart(id){
      $.ajax({
        type: 'POST',
        url: "/cart/add.js",
        data: { id:id,quantity:1 },
        dataType: "JSON",
        success: function(e) { 
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
        }
      });
    }
    function removeFromCart(id){
      $.ajax({
        type: 'POST',
        url: "/cart/change.js",
        data: { id:id,quantity:0 },
        dataType: "JSON",
        success: function(e) { 
          setCookie('remove_insurance','1',1);
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
        }
      });
    }
  window.checkIfInsuranceInCart = function(){
      var length = $(document).find('[data-variant_id="39714012332167"]').length;
      if(length == 1){
        //$(document).find('#shipping_protection').prop('checked',true)
      }
      var checkIfRemoved = getCookie('remove_insurance');
      console.log(checkIfRemoved +' '+length)
      $.ajax({
        type: 'GET',
        url: "/cart.js",
        dataType: "JSON",
        success: function(cart) { 
          var insIncart = 0;
          $.each(cart.items,function(i,item){
            if( item.variant_id === '39714012332167' || item.variant_id === 39714012332167 ){
              insIncart = 1;
            }
          });
          console.log(insIncart+' '+checkIfRemoved +'  '+cart.items.length);
          if( insIncart == 0 && checkIfRemoved !== '1' && cart.items.length > 0 ){
            console.log('clicked')
            addToCart(39714012332167)
            //$(document).find('label[for="shipping_protection"]').trigger('click')
          }
        }
      });
    }

  document.addEventListener('cart:refresh', function(event) {
    console.log('cart-refresh')
    setTimeout(function(){
     checkIfInsuranceInCart();
   },700)
  });
 
  document.addEventListener('variant:added', function(event) {
   setTimeout(function(){
     //checkIfInsuranceInCart();
   },700)
  });
  $(document).on('change','#shipping_protection',function(){
      var variant_id = $(this).val()
      if($(this).is(':checked')){
        addToCart(variant_id);
      }else{
        removeFromCart(variant_id);
      }
    });
    $(document).on('click','.footer-signup',function(e){
      $('.popup-pro').show();
    });
  $(document).on('click','[data-variant_id="39714012332167"] .line-item__remove-button',function(e){
      setCookie('remove_insurance','1',1);
    });
  
    $(document).on('click','.overlay,.close-popup',function(e){
      $('.popup-pro').hide();

    });
  $(document).on('click','#insurance_model #modalClose',function(e){
      $(this).closest('#insurance_model').removeClass('open')
    });
    $(document).on('click','.open_model',function(e){
      $(document).find('#insurance_model').addClass('open')
    });
  })
